export default __webpack_public_path__ + "static/media/forgot-password-email.cf343d18.png";